import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Account } from '@core/auth/account.model';
import { AccountService } from '@core/auth/account.service';
import { LoginService } from '@core/login/login.service';
import { PersonService } from '@core/user/person.service';
import { HomePageDTO } from '@model/homepage-dto.model';
import { TranslateService } from '@ngx-translate/core';
import { ProgramNewsService } from '@programs/program-news/program-news.service';

@Component({
  selector: 'jhi-tutorials',
  templateUrl: './tutorials.component.html',
  imports: [RouterLink],
  standalone: true,
})
export class TutorialsComponent implements OnInit {
  account?: Account | null;
  currentLanguage: string | undefined;
  homeInfo?: HomePageDTO;

  constructor(
    private accountService: AccountService,
    protected personService: PersonService,
    private translateService: TranslateService,
    private programNewsService: ProgramNewsService,
    private loginService: LoginService
  ) {}

  ngOnInit(): void {
    this.accountService.identity().subscribe(account => (this.account = account));
    this.currentLanguage = this.translateService.currentLang;
    this.programNewsService.newsHomepage().subscribe(res => {
      this.homeInfo = res.body || undefined;
    });
  }

  isAuthenticated(): boolean {
    return this.accountService.isAuthenticated();
  }

  login(): void {
    this.loginService.login();
  }

  getDescription(text?: string): string | undefined {
    if (text && text.length > 200) {
      return text.substr(0, 200);
    }
    return text;
  }
}
